/*
  How It Works — video behaviour.

  Two jobs, both delegated/observed from the document so they survive Shopify
  theme-editor section re-renders:

  1. YouTube facade: swaps the poster button for a real iframe on first
     click, so the page does not pay for ~1MB of third-party script upfront.
  2. Inline clips: muted looping MP4s ship with preload="none" so they cost
     nothing at page load. An IntersectionObserver starts one the moment it
     scrolls into view and pauses it on the way out. Visitors who prefer
     reduced motion just get the poster frame.

  More than one section loads this file; the guard makes the second execution
  a no-op so listeners never double-bind.
*/
(function () {
  'use strict';

  if (window.howToVideoInit) return;
  window.howToVideoInit = true;

  /* ---- YouTube facade ---- */

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-how-to-video-play]');
    if (!trigger) return;

    var wrapper = trigger.closest('[data-how-to-video]');
    if (!wrapper) return;

    var src = wrapper.getAttribute('data-video-src');
    if (!src) return;

    var iframe = document.createElement('iframe');
    iframe.setAttribute('src', src);
    iframe.setAttribute('title', wrapper.getAttribute('data-video-title') || 'Video player');
    iframe.setAttribute(
      'allow',
      'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
    );
    iframe.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute('frameborder', '0');

    trigger.remove();
    wrapper.appendChild(iframe);

    // Move focus into the player so keyboard users land on the controls
    // instead of being dropped back at the top of the document.
    iframe.focus();
  });

  /* ---- Inline clips ---- */

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  var clipObserver = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        var clip = entry.target;
        if (entry.isIntersecting && !reducedMotion.matches) {
          clip.muted = true;
          var playing = clip.play();
          if (playing) playing.catch(function () {});
        } else if (!clip.paused) {
          clip.pause();
        }
      });
    },
    { threshold: 0.3 }
  );

  function observeClips(root) {
    root.querySelectorAll('[data-how-to-clip]').forEach(function (clip) {
      clipObserver.observe(clip);
    });
  }

  observeClips(document);

  document.addEventListener('shopify:section:load', function (event) {
    observeClips(event.target);
  });
})();
